export default [
  {
    path: "/ai/chat",
    component: () => import("@/modules/hsf.ai/_views/ChatShell.vue"),
    redirect: { name: "aiChat" },
    children: [
      {
        path: ":id?",
        name: "aiChat",
        component: () => import("@/modules/hsf.ai/_views/ChatAi.vue"),
        meta: {
          title: "Generative AI",
          noShell: true,
        },
      },
      {
        path: "import-history",
        name: "aiImportHistory",
        component: () => import("@/modules/hsf.ai/_views/ImportHistory.vue"),
        meta: {
          title: "Import AI History",
          noShell: true,
        },
      },
    ],
  },
  {
    path: "/ai/prompt/studio",
    name: "aiPromptStudio",
    component: () => import("@/modules/hsf.ai/_views/PromptStudio.vue"),
    meta: {
      title: "AI / Prompt Studio",
      noShell: true,
    },
  },
];
